import { render } from "./invited.vue?vue&type=template&id=4d58f9fb"
import script from "./invited.vue?vue&type=script&lang=js"
export * from "./invited.vue?vue&type=script&lang=js"

import "./invited.vue?vue&type=style&index=0&id=4d58f9fb&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__